(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/account-balance-bar/assets/javascripts/account-balance-bar.js') >= 0) return;  svs.modules.push('/components/accountservices/account-balance-bar/assets/javascripts/account-balance-bar.js'); 
var svs = svs || {};
(function(svs) {
  'use strict';

  svs.accountservices = svs.accountservices || {};
  svs.accountservices.AccountBalanceBar = svs.accountservices.AccountBalanceBar || {};

  svs.accountservices.AccountBalanceBar.AccountBalance = function() {
    var $containerAccountBalanceBar = $('.js-account-balance-account-balance-bar'),
      $transactionsLinkAccountBalanceBar = $('.account-balance-bar-content .account-balance-bar-transactions'),
      showAccountBalance = false;

    function init() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.core.userSession.get('showAccountBalance', function(error, data) {
          showAccountBalance = Boolean(data);
          if (showAccountBalance) {
            getAccountBalance();
          } else {
            renderAccountBalance();
          }
        });
      }
      setupListeners();
    }

    function setupListeners() {
      $('.js-account-balance-account-balance-bar').on('click', function() {
        showAccountBalance = !showAccountBalance;
        svs.core.userSession.set('showAccountBalance', showAccountBalance, function() {
          if (showAccountBalance) {
            getAccountBalance();
          } else {
            renderAccountBalance();
          }
        });
      });

      svs.components.account_balance.on('change', renderAccountBalance);
    }

    function getAccountBalance() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.components.account_balance.get(true, renderAccountBalance);
      } else {
        hideAccountBalanceBar();
      }
    }

    function renderAccountBalance(balance) {
      if (Boolean(balance) && showAccountBalance) {
        $containerAccountBalanceBar.length > 0 && $containerAccountBalanceBar.html('Saldo: <span class="f-bold">' + svs.utils.format.Currency(balance) + ' kr</span>');
        $transactionsLinkAccountBalanceBar.css('display', 'inline-block');
      } else {
        $containerAccountBalanceBar.length > 0 && $containerAccountBalanceBar.html('Visa saldo');
        $transactionsLinkAccountBalanceBar.css('display', 'none');
      }
    }

    function hideAccountBalanceBar() {
      var $body = $(document.body);
      if ($body.hasClass('account-balance-bar-visible')) {
        $body.removeClass('account-balance-bar-visible');
      }
    }

    init();
  };

  new svs.accountservices.AccountBalanceBar.AccountBalance();
})(svs);

 })(window);